export class DateUtils {
    static formatDate = (date: Date): string => new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000).toISOString().split('T')[0];

    static formatDateToCsv = (date: Date | string): string => new Date(date).toLocaleDateString();

    static getCurrentTimezone = (): string => Intl.DateTimeFormat().resolvedOptions().timeZone;

    static getLastWeek = (): Date => {
        const now = DateUtils.getNow();
        const newDate = new Date(now);
        newDate.setDate(now.getDate() - 6);
        return newDate;
    };

    static getToday = (): Date => {
        const now = DateUtils.getNow();
        const newDate = new Date(now);
        newDate.setHours(0);
        return newDate;
    };

    static getNow = (): Date => new Date();

    static isSameDate = (d1: Date, d2: Date): boolean =>
        d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();

    static isToday = (date: Date): boolean => date && DateUtils.isSameDate(date, DateUtils.getNow());

    static sanitizeEndDateHours = (date: Date): Date => {
        if (DateUtils.isToday(date)) {
            return DateUtils.getNow();
        }

        date.setHours(23, 59, 59);
        return date;
    };
}
